import React, { useState } from 'react';

// Popup calendrier : s'ouvre immédiatement dans le popup (iframe).
// AUCUN nom de conseiller / client dans notre en-tête — seulement "Calendrier".
// Le contenu externe (iframe) est rogné en HAUT (masque nom conseiller) et en BAS
// (masque téléphone, termes, footer) pour n'afficher que les champs + bouton Réserver.
// Le commentaire généré par le script (calendarText) est en bas du popup, copiable.
export default function CalendarPopup({ advisor, onClose, isOpen, calendarText }) {
  const calendarUrl = advisor?.calendar_url || advisor?.spreadsheet_url;
  const topClip = advisor?.calendar_top_clip ?? 300;
  const bottomClip = advisor?.calendar_bottom_clip ?? 200;
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    if (!calendarText) return;
    navigator.clipboard.writeText(calendarText).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 5000, background: 'rgba(0,0,0,0.5)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16,
    }} onClick={e => e.target === e.currentTarget && onClose()}>
      <div style={{
        background: '#fff', borderRadius: 12,
        width: 'min(900px, 95vw)', height: 'min(750px, 95vh)',
        boxShadow: '0 24px 70px rgba(0,0,0,0.35)', display: 'flex', flexDirection: 'column',
        overflow: 'hidden',
      }} onClick={e => e.stopPropagation()}>
        {/* En-tête — AUCUN nom de conseiller / client (privacité, Karim 2026-10-30) */}
        <div style={{
          padding: '12px 16px', borderBottom: '1px solid var(--border)',
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          background: 'rgba(124,58,237,0.04)',
        }}>
          <div style={{ fontSize: 13, fontWeight: 800, color: 'var(--text)' }}>Calendrier</div>
          <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 20, color: 'var(--text2)', padding: 0, lineHeight: 1 }}>✕</button>
        </div>

        {/* Calendrier externe — s'ouvre immédiatement dans le popup (iframe).
             Rogné en haut (nom conseiller) et en bas (téléphone, termes, footer)
             pour n'afficher que les champs + bouton Réserver. */}
        <div style={{ flex: 1, overflow: 'hidden', background: '#fff' }}>
          {calendarUrl ? (
            <iframe
              src={calendarUrl}
              style={{
                width: '100%',
                height: `calc(100% + ${topClip + bottomClip}px)`,
                marginTop: -topClip,
                border: 'none',
                display: 'block',
              }}
              title="Calendrier conseiller"
              referrerPolicy="no-referrer"
              sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
            />
          ) : (
            <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--text2)' }}>
              Aucun lien de calendrier configuré.
            </div>
          )}
        </div>

        {/* Commentaire pour le calendrier client — BAS du popup, copiable */}
        {calendarText && (
          <div style={{
            padding: '12px 16px', borderTop: '1px solid var(--border)', background: '#fff',
          }}>
            <div style={{ fontSize: 11, fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.08em', color: 'var(--purple)', marginBottom: 8 }}>
              📝 Commentaire pour le calendrier client
            </div>
            <button onClick={handleCopy} style={{
              padding: '8px 12px', borderRadius: 6, border: '1px solid var(--border)',
              background: '#fff', cursor: 'pointer', fontSize: 12, color: 'var(--text)',
              marginBottom: 8, textAlign: 'left',
            }}>
              {copied ? '✓ Copié' : '📋 Copier le commentaire'}
            </button>
            <div style={{ padding: '10px 12px', background: 'rgba(124,58,237,0.06)', borderRadius: 8, borderLeft: '3px solid var(--purple)', fontSize: 12, color: 'var(--text)', lineHeight: 1.6, whiteSpace: 'pre-wrap', maxHeight: 150, overflowY: 'auto' }}>
              {calendarText}
            </div>
          </div>
        )}

        {/* Rappel fuseau */}
        <div style={{
          padding: '8px 16px', borderTop: '1px solid var(--border)', fontSize: 11, color: 'var(--text2)',
          background: 'rgba(245,158,11,0.06)',
        }}>
          🕐 Heure du Québec (Montréal) — vérifiez toujours le fuseau avant de réserver.
        </div>
      </div>
    </div>
  );
}
